import React, {useState, useEffect} from 'react'
import Layout from '../../../components/Layout/Layout'
import axios from 'axios'
import toast from 'react-hot-toast';
import { Link, useNavigate } from 'react-router-dom';
import { FaTrashAlt,FaPencilAlt,FaRegCheckCircle, FaExclamationCircle, FaUpload, FaImage } from "react-icons/fa";
import { dateInDMY, hasRight } from '../../../Helpers';
import { SERVER_API } from '../../../fileWithConstants';
import { Button,Modal } from 'react-bootstrap';
import { useAuth } from '../../../context/auth';
import Podetails from './Podetails';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
const ElementPolisting = () => {
    const [auth, setAuth] = useAuth();
    const [userId, setUserId] = useState(auth.user.id);

    const po_approve_right = hasRight(auth.user, 'po_approve');
    const upload_po_ack_right = hasRight(auth.user, 'upload_po_acknowledgement');
    const [poshow, setPoshow] = useState(false);
    const [podatashow, setPodatashow] = useState(false);
    const [poChildData, setPoChildData] = useState([]);
    const [podata, setPodata]=useState([]);
    const [selectedpo, setSelectedpo]=useState('');
    const [selected_po_id, setSelected_po_id]=useState('');
    const instructedByArr = ['Ketan Sethi','Maansi Sethi'];
    const [checkPo, setCheckPo] = useState([]);
    const [supplier, setSupplier] = useState([]);
    const [singleSelections, setSingleSelections] = useState([]);
    const [supplierId, setSupplierId] = useState("");
    const navigate = useNavigate();
    const getPodata = async()=>{
        try {
            const {data} = await axios.get(`${SERVER_API}/api/v1/element/get-element-po-data`);
            if(data?.success && data?.podata.length>0){
                setPodata(data?.podata);
            }else{
              toast.error('Some thing went wrong while getting PO data.')
            }
        } catch (error) {
            console.log(error)
        }
    }

    const getPodataBySupplierId = async(suppId)=>{
        try {
            const {data} = await axios.get(`${SERVER_API}/api/v1/element/get-element-po-data/${suppId}`);
            if(data?.success && data?.podata.length>0){
                setPodata(data?.podata);
            }else if(data?.success && data?.podata.length===0){
                setPodata([]);
                toast.error('No PO found for this supplier.');
            }else{
              toast.error('Some thing went wrong while getting PO data.')
            }
        } catch (error) {
            console.log(error)
        }
    }

    const getAllSupplier = async()=>{
        try {
          const {data} = await axios.get(`${SERVER_API}/api/v1/supplier/get-all-supplier`);
          if(data?.success && data?.suppliers?.length>0){
            setSupplier(data?.suppliers)
          }
        } catch (error) {
          console.log(error)
        }
    }

useEffect(()=>{
    getPodata();
    getAllSupplier();
},[])

useEffect(() => {
    if (singleSelections.length > 0) {
        const selectedId = singleSelections[0]?.v_id;

        if (supplierId !== selectedId) {
            getPodataBySupplierId(selectedId);
            setSupplierId(selectedId);
        }
    }
}, [singleSelections]);

const HandleApprove = (id, po_number)=>{
    if(!po_approve_right){
        alert('You have no right to approve PO.');
        return false;
    }
    setSelected_po_id(id)
    setSelectedpo(po_number)
    setPoshow(true)
    setSupplierId("");
}


const handleApprove = async () => {
  try {
    const { data } = await axios.post(
      `${SERVER_API}/api/v1/element/po-element-approve`,
      {
        po_id: selected_po_id,
        po_num: selectedpo,
        user_id: userId,
      }
    );

    if (data?.success) {
      toast.success(data.message);
      getPodata();
      setPoshow(false);
      setSupplierId("");
    }
  } catch (error) {
    //console.log(error);
    toast.error("Approve failed");
  }
};

const handleClose = ()=> {
    setPoshow(false);
    setPodatashow(false);
};

const handleEdit = (id)=>{
    navigate(`/dashboard/elements-po-edit/${id}`)
}

const handleShowPodata = async(id, po_number)=>{
    setSelected_po_id(id)
    setSelectedpo(po_number)
    const {data} = await axios.get(`${SERVER_API}/api/v1/element/get-single-element-po-data/${id}`);
    //console.log(data)
    if(data?.success && data?.posingledata.length>0){
        setPoChildData(data?.posingledata);
    }else{
        toast.error('Some thing went wrong while getting PO data.')
    }
    setPodatashow(true)
}

const handleDeletePo = async (id) => {
  const confirmDelete = window.confirm(
    "Are you sure you want to delete this PO?",
  );

  if (!confirmDelete) return;

  try {
    const { data } = await axios.delete(
      `${SERVER_API}/api/v1/element/delete-po-element/${id}`,
    );

    if (data?.success) {
      toast.success(data.message);

      // ✅ Instead of navigate, refresh list
      getPodata();
    } else {
      toast.error(data?.message || "Delete failed");
    }
  } catch (error) {
    //console.log(error);
    toast.error("Something went wrong while deleting");
  }
};

const handleCaheckBox = (e)=>{
    const current_po = Number(e.target.value);
    if(e.target.checked){
        setCheckPo([...checkPo,current_po])
    }else{
            if(checkPo.length>0){
                const afterRemoPO = checkPo.filter(po=> po!==current_po)
                setCheckPo(afterRemoPO)
            } 
    }
}

const handleReset = () => {
    setSingleSelections([]);
    setSupplierId("");
    getPodata();
};

const handleAck = async (event, po_id) => {
  if (!upload_po_ack_right) {
    alert("You have no right to upload Acknowledgement!");
    return;
  }

  const file = event.target.files[0];
  if (!file) return;

  try {
    const formData = new FormData();
    formData.append("po_id", po_id);
    formData.append("po_ack", file);

    const { data } = await axios.put(
      `${SERVER_API}/api/v1/element/upload-po-element-ack`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (data?.success) {
      toast.success(data.message);
      getPodata(); // refresh data only once
    } else {
      toast.error(data.message);
    }

  } catch (error) {
    //console.log(error);
    toast.error("Upload failed");
  }
};

  return (
    <Layout title={'Element Po Listing Page'}>
    <div className='container'>
    
        <div className='justify-content-center'>
        <h1 className='page-title'>Element Purchase Order List</h1>     

        <div className="row justify-content-center">
        <div className="col-md-12 custom-inline-form">
        
        
        <div className='form-box big-box'>
        <Typeahead
            inputProps={{ required: true }}
            name="supplier_id"
            id="basic-typeahead-single"
            labelKey="code"
            onChange={setSingleSelections}
            options={supplier}
            placeholder="Choose a supplier"
            selected={singleSelections}
        />
        </div>

        <div className='form-box btn-box'>
        <Button onClick={handleReset} className='btn btn-primary float-end'>Reset</Button>
        </div>
       
        <div className='form-box btn-box'>
        <Link to={'/dashboard/add-po-elements'} className='btn btn-primary float-end'>+ Add PO Order</Link>
        </div>
       </div>
       </div>
       <div className="row">
        <div className='col-md-12'>
            <div className='table-box'>
            <table className="table table-responsive table-hover table-sticky">
                <thead>
                    <tr className='align-item'>
                        <th scope="col">#</th>
                        <th scope="col" className='text-center'>PO No.</th>
                        <th scope="col" className='text-center'>Supplier</th>
                        <th scope="col" className='text-center'>Order Dt.</th>
                        <th scope="col" className='text-center'>Del. Dt.</th>
                        <th scope="col" className='text-start'>Instructed By</th>
                        <th scope="col" className='text-center'>Amount</th>
                        <th scope="col" className='text-center'>Acknowledgement</th> 
                        <th scope="col" className='text-center'>Status</th>  
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {podata?.map((po, index)=>(
                        <tr key={index}>
                            <td>{index+1} {po.status===1? supplierId!==''?<input type='checkbox' value={po.id} onChange={handleCaheckBox}/>:"":""}</td>
                            <td className='text-center' onClick={()=>{handleShowPodata(po.id,po.po_num)}}><Link to={'#'}>PO-{po.po_num}</Link></td>   
                            <td className='text-start'>{po.code}</td>
                            <td className='text-center'>{dateInDMY(po.po_date)}</td>
                            <td className='text-center'>{dateInDMY(po.del_date)}</td>
                            <td className='text-start'>
                                {po.instructed_by==='1'?instructedByArr[0]:po.instructed_by=='2'?instructedByArr[1]:''}
                            </td>
                            <td className='text-start'>{po.total} </td>
                            <td className='text-center'>                            
                            <div className='upload-button-box'>
                                {upload_po_ack_right && (
                                    <label className='upload-button-custom'>
                                    <input type="file" name='po_ack' accept="image/png, image/jpg, image/jpeg" onChange={(event)=>{handleAck(event,po.id)}} />
                                    <FaUpload/>
                                    </label>
                                )}

                              { po.ack_image!=='' && ( 
                                  <Link to={`${SERVER_API}/uploads/elements/${po.ack_image}`} target='_blank' className='ack-img'><FaImage /></Link>
                               )}
                            </div>
                            </td>
                            <td className='text-center'>
                                {po.status===1?<Link to={'#'}><span><FaRegCheckCircle className='text-success'/> Approved</span></Link>:<Link to={'javascript:void(0)'}><span onClick={()=>{HandleApprove(po.id,po.po_num)}}><FaExclamationCircle className='text-danger'/> Pending</span></Link>}
                                </td>
                            <td className='action-td'>

                            
                            {po.status==1?"":<Link to={'#'} title='Edit PO'><FaPencilAlt className='text-success' onClick={()=>{handleEdit(po.id)}} /></Link>}
                            {po.status==1?"":<Link to={'#'} title='Delete PO'><FaTrashAlt className='text-danger' onClick={()=>handleDeletePo(po.id)}/></Link>}
                            
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {checkPo.length>0 && <Link to={`/dashboard/po-element-inward?po-ids=${checkPo}`} className='btn btn-warning float-end'>Stock-In</Link>}
            </div>
        </div>
        </div>
        </div>
    </div>

    <Modal show={poshow} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>PO Number: PO-{selectedpo}</Modal.Title>
        </Modal.Header>
        <Modal.Body><FaExclamationCircle className='text-warning'/> Are you sure, you want to approve PO number <b>PO-{selectedpo}</b> ?</Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={handleApprove}>Yes</Button>
        </Modal.Footer>
    </Modal>

    <Modal size="lg" show={podatashow} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>PO Number: PO-{selectedpo}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Podetails poChildData={poChildData}/>
        </Modal.Body>
    </Modal>

    </Layout>
  )
}

export default ElementPolisting
